export { default as Container } from './Container';
export { default as Footer } from './Footer';
export { default as Section } from './Section';

export {
    Hero,
    Header as HeroHeader,
    Body as HeroBody,
    Video as HeroVideo,
    Footer as HeroFooter,
} from './Hero';


// WEBPACK FOOTER //
// ./src/layout/index.ts